import { render, staticRenderFns } from "./KBInvoicesPartners.vue?vue&type=template&id=672a8846&"
import script from "./KBInvoicesPartners.vue?vue&type=script&lang=ts&"
export * from "./KBInvoicesPartners.vue?vue&type=script&lang=ts&"
import style0 from "./KBInvoicesPartners.vue?vue&type=style&index=0&id=672a8846&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports